import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { ConfigResponse } from './types';

/**
 * Runtime configuration fetched from GET /v1/config — feature flags the
 * server was launched with. Used to enable/disable UI affordances (the
 * Licenses tab when RM_LICENSE_MANAGER_ENABLED=false, etc.). See
 * internal/handler/v1/config/get.go for the wire shape and which
 * fields are live vs startup-snapshot.
 *
 * Cache forever: these flags don't flip during a normal session. If a
 * feature later needs live behavior (e.g. operationLogEnabled tracking
 * the Settings page toggle), drop staleTime/gcTime to a finite value or
 * call queryClient.invalidateQueries({ queryKey: ['config'] }) on the
 * mutation that flips it.
 */
export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: () => api<ConfigResponse>('/v1/config'),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
